import React from "react";

export default function EditDoctorModal({ show, onClose, selectedDoctorForEdit, editDoctorFullForm, setEditDoctorFullForm, onSubmit }) {
  if (!show || !selectedDoctorForEdit) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Edit Doctor - {selectedDoctorForEdit.display_name || selectedDoctorForEdit.user_name}</h2>
        <form onSubmit={onSubmit}>
          <div className="admin-row">
            <label>Name *</label>
            <input
              type="text"
              required
              value={editDoctorFullForm.name}
              onChange={(e) => setEditDoctorFullForm({...editDoctorFullForm, name: e.target.value})}
            />
          </div>
          <div className="admin-row">
            <label>Email</label>
            <input
              type="email"
              value={selectedDoctorForEdit.email || selectedDoctorForEdit.user_name}
              disabled
              style={{ background: '#f3f4f6', color: '#6b7280' }}
            />
            <small style={{ color: '#6b7280', fontSize: '12px' }}>Email cannot be changed</small>
          </div>
          <div className="admin-row">
            <label>Phone</label>
            <input
              type="text"
              value={editDoctorFullForm.phone}
              onChange={(e) => setEditDoctorFullForm({...editDoctorFullForm, phone: e.target.value})}
            />
          </div>
          <div className="admin-row">
            <label>Display Name</label>
            <input
              type="text"
              value={editDoctorFullForm.display_name}
              onChange={(e) => setEditDoctorFullForm({...editDoctorFullForm, display_name: e.target.value})}
            />
          </div>
          <div className="admin-row">
            <label>Age</label>
            <input
              type="number"
              value={editDoctorFullForm.age}
              onChange={(e) => setEditDoctorFullForm({...editDoctorFullForm, age: e.target.value})}
            />
          </div>
          <div className="admin-row">
            <label>Gender</label>
            <select
              value={editDoctorFullForm.gender}
              onChange={(e) => setEditDoctorFullForm({...editDoctorFullForm, gender: e.target.value})}
            >
              <option value="">Select</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div className="admin-row">
            <label>Role/Specialization</label>
            <input
              type="text"
              value={editDoctorFullForm.role_specialization}
              onChange={(e) => setEditDoctorFullForm({...editDoctorFullForm, role_specialization: e.target.value})}
              placeholder="e.g., Psychiatrist, Psychologist, Therapist"
            />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
            <button type="submit" className="btn btn-primary">Update Doctor</button>
            <button type="button" className="btn" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
